import { GradeCatalog } from "./grade-catalog.model";
import { PipesCatalog } from "./pipes-catalog.model";
import { CatalogMetadata } from "./catalog-metadata.model";
import { CatalogScope } from "./catalog-scope.enum";

export class ConnectionCatalog {
    public constructor(init?: Partial<ConnectionCatalog>) {
      Object.assign(this, init);
      this.grade = init && init.grade ? new GradeCatalog(init.grade) : null;
      this.tubularPipe = init && init.tubularPipe ? new PipesCatalog(init.tubularPipe) : null;
      this.metadata = init && init.metadata ? new CatalogMetadata(init.metadata) : null;
    }

    id: string;
    name: string;
    tubularPipe: PipesCatalog;
    grade: GradeCatalog;
    outerDiameter: number;
    innerDiameter: number;
    burstRating: number;
    collapseRating: number;
    tensionRating: number;
    compressionRating: number;
    isLocked: boolean;
    metadata: CatalogMetadata;
    tleProfile: any[];
    scope: CatalogScope;

    tubularPipeLookup: PipesCatalog[];
  }
